import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  formControlLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginLeft: 0,
    gap: theme.spacing(1),
  },
  lockedBox: {
    cursor: 'not-allowed',
    '& *': { pointerEvents: 'none' },
  },
  skeletonBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  groupLabelBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}))

export default useStyles
